import React from 'react'
import { Helmet } from 'react-helmet'
import { motion } from 'framer-motion'

import Ambient from 'components/Ambient'
import logo from 'style/logo.png'
import pawIcon from 'style/icons/paw.png'
import snootIcon from 'style/icons/snoot.png'

const ease = [0.22, 1, 0.36, 1]

const word = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07, delayChildren: 0.28 } }
}

const letter = {
  hidden: { opacity: 0, y: 18, filter: 'blur(10px)' },
  show: {
    opacity: 1,
    y: 0,
    filter: 'none',
    transition: { duration: 0.7, ease }
  }
}

const vowel = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.7, ease }
  }
}

const fade = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.85, ease } }
}

const MARK = [
  { ch: 'C', kind: 'consonant' },
  { ch: 'R', kind: 'consonant' },
  { ch: 'i', kind: 'vowel vowel-i' },
  { ch: 'S', kind: 'consonant' },
  { ch: 'P', kind: 'consonant' },
  { ch: 'y', kind: 'vowel vowel-y' }
]

const Home = () => {
  return (
    <div className="page">
      <Helmet>
        <title>CRSP - Sharp work. No crumbs.</title>
      </Helmet>

      <Ambient />

      <main className="stage">
        <div className="logo-orbit">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, ease }}>
            <div className="logo-hover">
              <img className="logo-mark" src={logo} alt="CRSP" />
            </div>
          </motion.div>
        </div>

        <motion.h1 className="wordmark" variants={word} initial="hidden" animate="show">
          {MARK.map(({ ch, kind }) => (
            <motion.span
              key={ch}
              className={kind}
              variants={kind.startsWith('vowel') ? vowel : letter}>
              {ch}
            </motion.span>
          ))}
        </motion.h1>

        <motion.p className="tagline" variants={fade} initial="hidden" animate="show">
          Sharp work. No crumbs.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.95, ease }}>
          <a className="cta" href="mailto:hannes@crsp.co">
            Let&apos;s talk
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </motion.div>

        <motion.div
          className="projects"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.1, ease }}>
          <a className="project" href="https://paw.crsp.co">
            <span className="project-head">
              <img className="project-icon" src={pawIcon} alt="" />
              <span className="project-name">Packing-Awesome</span>
            </span>
            <span className="project-blurb">
              Packing lists for trips — clothes, kits, and meds, ticked off as you go.
            </span>
          </a>
          <a className="project" href="https://snoot.crsp.co">
            <span className="project-head">
              <img className="project-icon" src={snootIcon} alt="" />
              <span className="project-name">Snoot</span>
            </span>
            <span className="project-blurb">
              A pet health and wellness tracker — records, notes, and day-to-day care in one place.
            </span>
          </a>
        </motion.div>
      </main>
    </div>
  )
}

export default Home
